import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "./root";
import { ErrorExplorer } from "../features/errors";

export const errorsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/explore-errors",
  component: function ErrorsRoute() {
    return <ErrorExplorer />;
  },
});
